<ds-modal [title]="modalTitleAndActionName | translate" [maxWidthPercentage]="80" (modalClosed)="onCancel()">
  <div class="modal-content-wrapper">
    @if (changeTo === DigitalPropertyStateAction.archive) {
      <p>{{ 'selfmanage_archive_digital_asset_confirmation_text' | translate }}</p>
    } @else {
      <p>{{ 'selfmanage_restore_digital_asset_confirmation_text' | translate }}</p>
    }
    <div class="d-flex gap-3">
      <button ds-button [variant]="DsButtonVariants.primary" (click)="onChangeConfirmed()">
        {{ modalTitleAndActionName | translate }}
      </button>
      <button ds-button [variant]="DsButtonVariants.secondary" (click)="onCancel()" data-test-id="cancel-button">
        {{ 'label_cancel' | translate }}
      </button>
    </div>
  </div>
</ds-modal>
